// libs
import React from 'react';
import { Route, Switch } from 'react-router-dom';

// styles
import './paymentGatewayCredentials.scss';

// components
import PaymentGatewayCredentialsPage from './PaymentGatewayCredentialsPage';
import CreatePaymentGatewayCredentials from './CreatePaymentGatewayCredentials';
import EditPaymentGatewayCredentials from './EditPaymentGatewayCredentials';

const PaymentGatewayCredentials = () => {
     return (
        <>
            <div className="payment-gateway-credentials-wrapper">
                <Switch>
                    <Route exact path="/payment-gateway-credentials">
                        <PaymentGatewayCredentialsPage />
                    </Route>
                    <Route path="/payment-gateway-credentials/create/:boardingType">
                        <CreatePaymentGatewayCredentials />
                    </Route>
                    <Route path="/payment-gateway-credentials/edit/:boardingType/:referenceId">
                        <EditPaymentGatewayCredentials
                            isEditMode={true}
                            isViewMode={false}
                        />
                    </Route>
                    <Route path="/payment-gateway-credentials/view/:boardingType/:referenceId">
                        <EditPaymentGatewayCredentials
                            isEditMode={true}
                            isViewMode={true}
                        />
                    </Route>
                </Switch>
            </div>
        </>
    );
};

export default PaymentGatewayCredentials;
